import type { Settings } from 'types';
import camelcaseKeys from 'camelcase-keys';
import { request } from 'lib/rest';
import { locales as NEXT_LOCALES } from 'i18n.mjs';

export type WPLanguageCode = keyof typeof NEXT_LOCALES;
export type AppLocale = typeof NEXT_LOCALES[WPLanguageCode];

export enum LanguageCodeFilterEnum {
  All = 'ALL',
  Br = 'BR',
  De = 'DE',
  Default = 'DEFAULT',
  En = 'EN',
  Es = 'ES',
}

export enum LanguageCodeEnum {
  Br = 'BR',
  De = 'DE',
  En = 'EN',
  Es = 'ES',
}

export function getLanguageCode(locale: string): LanguageCodeEnum {
  switch (locale) {
    case NEXT_LOCALES.es:
      return LanguageCodeEnum.Es;
    default:
      return LanguageCodeEnum.En;
  }
}

export function getLanguageSlug(locale: string): WPLanguageCode {
  return Object.keys(NEXT_LOCALES).find(
    key => NEXT_LOCALES[key] === locale,
  ) as WPLanguageCode;
}

export function getLanguageCodeFilter(locale: string): LanguageCodeFilterEnum {
  const language = getLanguageCode(locale) as unknown;

  return language as LanguageCodeFilterEnum;
}

export async function getSettings(locale: string): Promise<Settings> {
  const { error, data } = await request<Settings>(`/site-settings`, {
    headers: {
      'Accept-Language': locale,
    },
  });

  if (error) {
    throw { error };
  }

  const { translations, ...rest } = data.items;

  return {
    ...camelcaseKeys(rest, { deep: true }),
    translations,
  };
}
